//FAQ

import styled from 'styled-components'
import { useInView } from 'react-intersection-observer';
import { show } from '../utils/utils';
// import * as images from '../Images/images/*.jpg';

const Faq = styled.div`
// border: 1px solid white;
color: white;
height: 60vh;
display: flex;
align-items: center;
justify-content: center;
`

const GalleryList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 840px;
  max-height: 840px;
  overflow: hidden;
  margin: 1% auto 0 auto;
`;


const GalleryItem = styled.div`
  width: 120px;
  margin: 10px;
  transition: all 0.2s ease;
  will-change: transform;
  position: relative;
  z-index: 10;
  
  img {
    width: 100%;
    height: auto;
    border-radius: 100px;
  }
  :hover {
    transform: scale(1.2);
  }
`;

function importAll(r) {
    let images = {};
     r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images
}


export default function FAQ() {
    const images = importAll(require.context('../Images/images', false, /\.(png|jpe?g|svg)$/));
    let values = Object.values(images).sort((a, b) => {
        return parseInt(a.split('/')[3].split('.')[0])  - parseInt(b.split('/')[3].split('.')[0]);
    })
    const { ref, inView } = useInView({});


    return (
            <Faq id="FAQ" ref={ref} className={show(inView)}>
            <GalleryList>
                {values.map((art, idx) => {
                    return (<GalleryItem key={idx}><img src={art} alt="Image Show" /></GalleryItem>);
                })}
            </GalleryList>
            </Faq>


    )
}